import { DEFAULTS } from './services/config';
import { initNavigator } from './services/initNavigator';
import { initToolbar } from './services/initToolbar';
import { clearContainer } from './utils/domUtils';

export class NavigatorService {
  constructor(element, scroller, theme, documentObj) {
    this.element = element;
    this.scroller = scroller;
    this.theme = theme;
    this.document = documentObj || window.document;
    this.containerId = DEFAULTS.containerId;
    this.transitionCanceled = false;
    this.onFullscreenChange = this.updateToolbarButtons.bind(this);
    this.backgroundImage = null;
  }

  create(scroller) {
    clearContainer(this.element);

    this.toolbar = initToolbar(scroller);
    this.element.appendChild(this.toolbar.el);
    this.toolbar.on('fullscreen:pointerclick', () => this.toggleFullscreen());
    this.toolbar.on('minimap:pointerclick', () => this.toggleMinimap());
    this.toolbar.on('zoom-out-min:pointerclick', () => this.zoomOutToMinimum());
    this.document.addEventListener('fullscreenchange', this.onFullscreenChange);

    this.navigator = initNavigator(scroller, this.backgroundImage);
    this.element.prepend(this.navigator.el);
    this.navigator.render();

    this.hideMinimap();
    this.updateToolbarButtons();
  }

  isMinimapVisible() {
    return !this.navigator.el.classList.contains('hidden');
  }

  showMinimap() {
    this.navigator.el.classList.remove('hidden');
    this.navigator.el.style.height = `${DEFAULTS.minimap.height}px`;
    this.transitionCanceled = false;
  }

  hideMinimap() {
    this.navigator.el.classList.add('hidden');
    this.navigator.el.style.height = '0px';
  }

  toggleMinimap() {
    this.isMinimapVisible() ? this.hideMinimap() : this.showMinimap();
    this.updateToolbarButtons();
  }

  toggleFullscreen() {
    const mapContainer = this.document.getElementById(this.containerId);
    if (!this.document.fullscreenElement) {
      mapContainer?.requestFullscreen().catch(console.error);
    } else {
      this.document.exitFullscreen().catch(console.error);
    }
  }

  updateToolbarButtons() {
    const minimapBtn = this.toolbar.getWidgetByName('minimap');
    minimapBtn.setTooltip(this.isMinimapVisible() ? 'Hide minimap' : 'Afficher la mini-carte');

    const fsBtn = this.toolbar.getWidgetByName('fullscreen');
    const isFs = Boolean(this.document.fullscreenElement);
    fsBtn.setIcon(isFs ? 'exit-fullscreen' : 'fullscreen');
    fsBtn.setTooltip(isFs ? 'Désactiver le mode plein écran' : 'Activer le mode plein écran');
  }

  zoomOutToMinimum() {
    if (window.rappidInstance) {
      window.rappidInstance.zoomOutToMinimum();
    }
  }

  destroy() {
    this.toolbar.remove();
    this.navigator.remove();
    this.document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    clearContainer(this.element);
  }
}
